import type { C1_FurnitureDefinition, C1_FurnitureRendererProps } from "../../types/C1_FurnitureTypes";
import { RoomType } from "../../types/C1_ModelTypes";
import { C1_FurnitureSvg } from "../C1_FurnitureSvg";
import { C1_FurnitureIcon } from "../C1_FurnitureIcon";

const DEFAULT_WIDTH = 2.4;
const DEFAULT_HEIGHT = 0.6;

const KitchenBlock: C1_FurnitureDefinition = {
  id: "kitchenBlock",
  icon: <C1_FurnitureIcon kind="kitchen-block" />,
  description: { en: "Kitchen block with sink and hob", de: "Küchenblock" },
  category: RoomType.Kitchen,
  defaultWidth: DEFAULT_WIDTH,
  defaultHeight: DEFAULT_HEIGHT,
  grabsW: true,
  grabsH: false,
  originXPercentage: 50,
  originYPercentage: 50,
  properties: [],
  Renderer: ({
    width,
    height,
    rotation,
    PX,
    strokeWidth,
    strokeColor,
    fillColor,
    showDetails,
  }: C1_FurnitureRendererProps) => {
    const finalStrokeWidth = strokeWidth ?? 2;
    const finalStrokeColor = strokeColor ?? "#000000";
    const outerInset = 0.02 * PX;
    const sinkWidth = 0.5 * PX;
    const sinkHeight = 0.36 * PX;
    const sinkX = 0.18 * PX;
    const sinkY = (height - sinkHeight) / 2;
    const hobRadius = 0.08 * PX;
    const hobLeftX = width - 0.85 * PX;
    const hobRightX = width - 0.55 * PX;
    const hobTopY = height / 2 - 0.11 * PX;
    const hobBottomY = height / 2 + 0.11 * PX;

    return (
      <C1_FurnitureSvg
        PX={PX}
        width={width}
        height={height}
        rotation={rotation ?? 0}
        viewBoxWidth={width}
        viewBoxHeight={height}
        originXPercentage={50}
        originYPercentage={50}
      >
        <rect
          x={outerInset}
          y={outerInset}
          width={Math.max(0, width - outerInset * 2)}
          height={Math.max(0, height - outerInset * 2)}
          rx={outerInset}
          fill={fillColor ?? "#ffffff"}
          stroke={finalStrokeColor}
          strokeWidth={finalStrokeWidth * 2}
        />
        {showDetails && (
          <>
            <rect
              x={sinkX}
              y={sinkY}
              width={sinkWidth}
              height={sinkHeight}
              rx={0.08 * PX}
              fill="none"
              stroke={finalStrokeColor}
              strokeWidth={finalStrokeWidth}
            />
            <circle
              cx={hobLeftX}
              cy={hobTopY}
              r={hobRadius}
              fill="none"
              stroke={finalStrokeColor}
              strokeWidth={finalStrokeWidth}
            />
            <circle
              cx={hobRightX}
              cy={hobTopY}
              r={hobRadius}
              fill="none"
              stroke={finalStrokeColor}
              strokeWidth={finalStrokeWidth}
            />
            <circle
              cx={hobLeftX}
              cy={hobBottomY}
              r={hobRadius}
              fill="none"
              stroke={finalStrokeColor}
              strokeWidth={finalStrokeWidth}
            />
            <circle
              cx={hobRightX}
              cy={hobBottomY}
              r={hobRadius}
              fill="none"
              stroke={finalStrokeColor}
              strokeWidth={finalStrokeWidth}
            />
          </>
        )}
      </C1_FurnitureSvg>
    );
  },
};

export default KitchenBlock;
